export default {
  'removed-from-cart': { message: 'Produit supprimé de votre panier' },
  'batch-discount': {
    message1: 'Promotion ',
    message2: ' appliquée à votre panier',
  },
};
